module.exports = __webpack_public_path__ + "img/gamingtime.09ac2de5.jpg";